import React from 'react';
import { SET_PAGE_TITLE, SET_PAGE_SUB_TITLE, SET_SITE_LANG, SET_SIDER_WIDTH, SET_INV_COOKIE } from '../_types';
import { getCookie, setCookie } from '../../utils/helpers';
import { FormattedMessage } from "react-intl";

const initialState = {
    pageTitle: 'Esoko',
    pageSubTitle: '',
    lang: getCookie('site_lang') || 'en',
    inv_exists: false,
    inv_accountId: '',
    inv_email: getCookie('inv_email'),
    inv_person: JSON.parse(getCookie('inv_person') || '{}'),
    inv_account: JSON.parse(getCookie('inv_account') || '{}'),
    siderWidth: 256,
    industries: {
        'Agriculture': <FormattedMessage id="Industry.Agriculture" defaultMessage="Agriculture" />,
        'ArtsEntertainmentRecreation': <FormattedMessage id="Industry.ArtsEntertainmentRecreation" defaultMessage="Arts, Entertainment, and Recreation" />,
        'Automobile': <FormattedMessage id="Industry.Automobile" defaultMessage="Automobile" />,
        'Aviation': <FormattedMessage id="Industry.Aviation" defaultMessage="Aviation" />,
        'Construction': <FormattedMessage id="Industry.Construction" defaultMessage="Construction" />,
        'Ecommerce': <FormattedMessage id="Industry.Ecommerce" defaultMessage="Ecommerce" />,
        'Education': <FormattedMessage id="Industry.Education" defaultMessage="Education" />,
        'Finance': <FormattedMessage id="Industry.Finance" defaultMessage="Finance" />,
        'Gaming': <FormattedMessage id="Industry.Gaming" defaultMessage="Gaming" />,
        'Government': <FormattedMessage id="Industry.Government" defaultMessage="Government" />,
        'HealthServices': <FormattedMessage id="Industry.HealthServices" defaultMessage="Health Services" />,
        'Hospitality': <FormattedMessage id="Industry.Hospitality" defaultMessage="Hospitality" />,
        'InformationTechnology': <FormattedMessage id="Industry.InformationTechnology" defaultMessage="Information Technology" />,
        'Insurance': <FormattedMessage id="Industry.Insurance" defaultMessage="Insurance" />,
        'Manufacturing': <FormattedMessage id="Industry.Manufacturing" defaultMessage="Manufacturing" />,
        'Media': <FormattedMessage id="Industry.Media" defaultMessage="Media" />,
        'NaturalResourcesMining': <FormattedMessage id="Industry.NaturalResourcesMining" defaultMessage="Natural Resources and Mining" />,
        'NonProfitOrganization': <FormattedMessage id="Industry.NonProfitOrganization" defaultMessage="Non-Profit Organization" />,
        'OilGas': <FormattedMessage id="Industry.OilGas" defaultMessage="Oil and Gas" />,
        'Pharmaceutical': <FormattedMessage id="Industry.Pharmaceutical" defaultMessage="Pharmaceutical" />,
        'ProfessionalBusinessServices': <FormattedMessage id="Industry.ProfessionalBusinessServices" defaultMessage="Professional and Business Services" />,
        'RealEstate': <FormattedMessage id="Industry.RealEstate" defaultMessage="Real Estate" />,
        'Other': <FormattedMessage id="Industry.Other" defaultMessage="Other" />,
    },
};

const utilsReducer = (state = initialState, action) => {
    switch (action.type) {
        default:
            return state;

        case SET_PAGE_TITLE:
            return {
                ...state,
                pageTitle: action.title
            }

        case SET_PAGE_SUB_TITLE:
            return {
                ...state,
                pageSubTitle: action.title
            };
        case SET_SITE_LANG:
            return {
                ...state,
                lang: action.lang
            };
        case SET_SIDER_WIDTH:
            return {
                ...state,
                siderWidth: action.width
            };

        case SET_INV_COOKIE:
            if (['inv_email', 'inv_accountId'].includes(action.key)) {
                setCookie(action.key, action.value);
            } else {
                setCookie(action.key, JSON.stringify(action.value));
            }
            return {
                ...state,
                [action.key]: action.value
            };
    }
};


export default utilsReducer;